<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <h3>Liste des {{ user ? 'sites' : 'utilisateurs' }} rattachés</h3>
      </v-col>
    </v-row>
    <v-row v-if="items && items.length > 0">
      <v-col>
        <v-text-field
          v-model="search"
          prepend-icon="search"
          label="Rechercher..."
          single-line
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-skeleton-loader
          v-if="loading === true"
          type="table"
          tile
          class="mx-auto"
        />
        <v-data-table
          v-else-if="items.length > 0"
          class="elevation-2"
          :search="search"
          :headers="headers"
          :items="items"
          :item-key="dataTableKey"
        >
          <template v-slot:top>
            <h4 class="py-2 pl-4">
              {{
                `${
                  user
                    ? 'Sites rattachés à cet utilisateur'
                    : 'Utilisateurs rattachés à ce site'
                } (${items.length})`
              }}
            </h4>
          </template>
        </v-data-table>
        <span v-else>{{
          user
            ? 'Aucun site rattaché à cet utilisateur.'
            : 'Aucun utilisateur rattaché à ce site.'
        }}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn class="scdf-yellow" @click="edit()">
          <v-icon class="mr-1">create</v-icon>
          EDITER
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SiteInterfaceViewer',
  props: {
    dataTableKey: {
      type: String,
      default: null,
    },
    headers: {
      type: Array,
      default: null,
    },
    user: {
      type: Object,
      default: null,
    },
    site: {
      type: Object,
      defualt: null,
    },
  },
  data() {
    return {
      search: '',
      ready: false,
      items: null,
      loading: true,
    };
  },
  created() {
    if (this.user) {
      this.loadSites();
    } else if (this.site) {
      this.loadUsers();
    }
  },
  methods: {
    loadUsers() {
      this.loading = true;
      axios({
        method: 'get',
        url:
          process.env.VUE_APP_BASE_URL +
          process.env.VUE_APP_SITE_REPOSITORY +
          `/${this.site.refSite.id}/users`,
        headers: {
          user: this.$store.state.user,
        },
      })
        .then(res => {
          this.items = res.data._embedded.datas;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadSites() {
      this.loading = true;
      axios({
        method: 'get',
        url:
          process.env.VUE_APP_BASE_URL +
          process.env.VUE_APP_USER_REPOSITORY +
          `/${this.user.id}?projection=site`,
        headers: {
          user: this.$store.state.user,
        },
      })
        .then(res => {
          this.items = res.data.sites;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    edit() {
      this.$emit('edit');
    },
  },
  watch: {
    user: {
      handler() {
        this.loadSites();
      },
    },
    site: {
      handler() {
        this.loadUsers();
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
